import { Component } from "react";
import type { ReactNode } from "react";
import * as Sentry from "@sentry/react";

type Props = { fallback: ReactNode };

export default class ComponentErrorBoundary extends Component<
  Props,
  { hasError: boolean }
> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static defaultProps = { fallback: null };

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    Sentry.captureException(error, { extra: errorInfo });
    console.error("Component ErrorBoundary", error);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}
